import ContextContentContainer from 'Containers/ContextContent';

import { ConversationEmptyState } from 'Modules/conversation/components/ConversationEmptyState';
import React from 'react';
import { cn } from '~/lib/utils';
import { PreviewConversationContentProps } from './index.types';

export const PreviewConversationContent = ({
  previewConversationId,
  isContactSelected,
  showEmpty,
  scrollContainerRef,
  className,
}: PreviewConversationContentProps) => {
  if (!previewConversationId) {
    return <ConversationEmptyState isContactSelected={isContactSelected} />;
  }

  return (
    <div className={cn('relative w-full h-full', className)}>
      <div
        ref={scrollContainerRef}
        className={cn(
          'w-full h-full overflow-y-auto',
          showEmpty && 'invisible'
        )}
      >
        <ContextContentContainer
          className="h-full"
          previewConversationId={previewConversationId}
        />
      </div>

      {showEmpty && (
        <div className="absolute inset-0 flex items-center justify-center">
          <ConversationEmptyState isContactSelected={isContactSelected} />
        </div>
      )}
    </div>
  );
};
